import isPermissionEnabled from "common/isPermissionEnabled"
import Breadcrumbs from "components/Common/Breadcrumb"
import formatDateTime from "components/Shared/formatDateTime"
import TableShimmer from "components/Shared/TableShimmer"
import React, { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import { useDispatch, useSelector } from "react-redux"
import { useNavigate } from "react-router-dom"
import {
  Badge,
  Button,
  Card,
  CardBody,
  CardTitle,
  Col,
  Input,
  Label,
  ModalFooter,
  Row,
  Table,
} from "reactstrap"
import { Modal, ModalHeader, ModalBody } from "reactstrap"
import { getPosCountryLists, updateApiKey } from "store/actions/posAction"
import { showAlert } from "store/reducers/alertReducer"

const APIKey = () => {
  const {
    t,
    i18n: { language },
  } = useTranslation()

  document.title = t("API Keys ")

  const dispatch = useDispatch()
  const navigate = useNavigate()
  const [selectedId, setSelectedId] = useState(null)
  const [isModal, setIsModal] = useState(false)
  const { loading, isLoading, currentPage, posCountries } = useSelector(
    state => state.POS
  )
  const [apiKey, setApiKey] = useState("")

  const toggleModal = () => {
    setIsModal(!isModal)
  }

  const { userRole, accountType } = useSelector(state => state.Login)

  const [permissions, setPermissions] = useState({
    list: null,
    edit: null,
  })

  // FIRST CHECK PERMISSION, IF DOES'T HAVE THEN REDIRECT TO DASHBOARD
  useEffect(() => {
    const isPermissionList = isPermissionEnabled(
      userRole,
      28,
      "api_key_1",
      accountType
    )

    const isPermissionEdit = isPermissionEnabled(
      userRole,
      28,
      "api_key_3",
      accountType
    )

    if (!isPermissionList) {
      navigate("/dashboard")
    }
    setPermissions({
      list: isPermissionList,
      edit: isPermissionEdit,
    })
  }, [userRole])

  useEffect(() => {
    fetchPOSBranch()
  }, [])

  const fetchPOSBranch = (page = 1) => {
    const payload = {
      perPage: 100,
      pageNo: 1,
      orderBy: 1,
    }
    dispatch(getPosCountryLists(payload))
  }

  const handleUpdateAPIClick = (id, apiKey) => {
    setSelectedId(id)
    toggleModal()
    const updatedAPIKey = apiKey ? apiKey : ""
    setApiKey(updatedAPIKey)
  }

  const handleUpdateAPIKey = () => {
    const payload = {
      id: selectedId,
      apiKey,
    }
    dispatch(updateApiKey(payload))
      .then(action => {
        const { statusCode, status, msg, message } = action?.payload
        if (statusCode === 200 && status) {
          dispatch(showAlert({ text: msg || message, type: "success" }))
          setSelectedId(null)
          setApiKey("")
          toggleModal()
        } else {
          dispatch(showAlert({ text: msg || message, type: "error" }))
        }
      })
      .catch(error => {
        dispatch(
          showAlert({
            text: t("This key is not authorized"),
            type: "error",
          })
        )
      })
  }

  return (
    <>
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs />
          <Row>
            <Col xl={12}>
              <Card>
                <CardBody>
                  <CardTitle>{t("API Keys List")}</CardTitle>
                  <div className="">
                    {loading ? (
                      <TableShimmer row={7} col={5} />
                    ) : posCountries.length === 0 ? (
                      <p className="text-center my-2">{t("No data found")}</p>
                    ) : (
                      <Table className="table mb-0" hover>
                        <thead className="table-light full_th">
                          <tr>
                            <th>{t("S. No.")}</th>
                            <th>{t("Country Code")}</th>
                            <th>{t("Country Name")}</th>
                            <th>{t("Updated At")}</th>
                            <th>{t("POS Status")}</th>
                            {permissions.edit && <th>{t("Action")}</th>}
                          </tr>
                        </thead>
                        <tbody>
                          {posCountries.map((item, index) => (
                            <tr key={item._id}>
                              <th scope="row">
                                {(currentPage - 1) * 10 + index + 1}
                              </th>
                              <td>{item.countryCode}</td>
                              <td>
                                {language === "sa"
                                  ? item?.country?.nameAr
                                  : item?.country?.name}
                              </td>
                              <td>{formatDateTime(item?.updatedAt)}</td>
                              <td>
                                {item?.apiKey ? (
                                  <Badge className="bg-success">
                                    {t("Connected")}
                                  </Badge>
                                ) : (
                                  <Badge className="bg-danger">
                                    {t("Not Connected")}
                                  </Badge>
                                )}
                              </td>
                              {permissions.edit && (
                                <td>
                                  <i
                                    onClick={() => {
                                      handleUpdateAPIClick(
                                        item._id,
                                        item.apiKey
                                      )
                                    }}
                                    className="mdi mdi-pencil font-size-18 text-success mx-2 cursor-pointer"
                                  ></i>
                                </td>
                              )}
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                    )}
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
      <Modal isOpen={isModal} toggle={toggleModal} centered>
        <ModalHeader toggle={toggleModal}>{t("Update API Key")}</ModalHeader>
        <ModalBody>
          <div className="form_field">
            <Label>{t("API Key")}</Label>
            <Input
              type="text"
              value={apiKey}
              onChange={e => setApiKey(e.target.value)}
              placeholder={t("Enter API Key")}
            />
          </div>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={toggleModal}>
            {t("Cancel")}
          </Button>
          <Button
            color="primary"
            disabled={!apiKey || isLoading}
            onClick={handleUpdateAPIKey}
          >
            {t("Update")}
          </Button>
        </ModalFooter>
      </Modal>
    </>
  )
}

export default APIKey
